import CoverLink from "components/Cover/CoverLink";
import { LetterbookGoalType, LetterbooksGoalConditionType } from "features/Letterbooks/types";

export default function LetterbookGoalShelf({
  letterbook,
  settings,
}: {
  settings: LetterbooksGoalConditionType;
  letterbook: LetterbookGoalType;
}) {
  const { data } = letterbook;
  const { userBookRead }  = data;
  
  if (!userBookRead) {
    return <></>;
  }

  return (
    <div className="flex flex-row">
      <CoverLink
        size="md"
        book={letterbook.book}
        edition={userBookRead?.edition}
        settings={{
          referrerId: settings.referrer_id,
        }}
      />
    </div>
  );
}
